import { ReactNode } from 'react';
import './style.scss';

const FixedScrollNavigation = ({ onClick, label }: { onClick?: () => void; label: ReactNode }) => (
  <div className="fixed-scroll-navigation" onClick={onClick}>
    {label}
  </div>
);

export default FixedScrollNavigation;
